// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3giel","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1uf2-","attentionStroke":"IconEmailAttention_attentionStroke__wap4I"};